// Semantic versioning for every PopCart release (docs/APP-UPDATES.md, "Versions and update prompts").
// Plain MAJOR.MINOR.PATCH only: no "v" prefix, no pre-release or build tags, no leading zeros.
// One source for the publish scripts, the API, the version check and the apps.

const SEMVER_RE = /^(0|[1-9]\d{0,5})\.(0|[1-9]\d{0,5})\.(0|[1-9]\d{0,5})$/;

/** "1.4.2" → [1, 4, 2]; null for anything else. */
export function parseSemver(v) {
  const m = SEMVER_RE.exec(typeof v === 'string' ? v : '');
  return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : null;
}

export const isSemver = (v) => parseSemver(v) !== null;

/** Negative, 0 or positive like a sort comparator; null when either side isn't semver. */
export function compareSemver(a, b) {
  const x = parseSemver(a);
  const y = parseSemver(b);
  if (!x || !y) return null;
  return x[0] - y[0] || x[1] - y[1] || x[2] - y[2];
}

/** 'major' | 'minor' | 'patch' for a forward move from → to; null when it isn't one (same, lower, not semver). */
export function bumpKind(from, to) {
  const x = parseSemver(from);
  const y = parseSemver(to);
  if (!x || !y || compareSemver(from, to) >= 0) return null;
  if (y[0] !== x[0]) return 'major';
  if (y[1] !== x[1]) return 'minor';
  return 'patch';
}

/** The version after a bump: bumpSemver('1.4.2', 'minor') → '1.5.0'. */
export function bumpSemver(v, kind) {
  const x = parseSemver(v);
  if (!x) return null;
  if (kind === 'major') return `${x[0] + 1}.0.0`;
  if (kind === 'minor') return `${x[0]}.${x[1] + 1}.0`;
  if (kind === 'patch') return `${x[0]}.${x[1]}.${x[2] + 1}`;
  return null;
}

/**
 * How an installed copy treats a published release, the same rule on every surface. Owner
 * (2026-10-14): every update is REQUIRED and its prompt stays on top of everything, with no "Later".
 *   'none'     nothing newer (or either version isn't semver)
 *   'required' anything newer: PATCH, MINOR or MAJOR
 * The bump kind still says what changed (bumpKind); it no longer decides whether users may wait.
 */
export function updateUrgency(installed, published) {
  return bumpKind(installed, published) ? 'required' : 'none';
}
